module.exports = __webpack_public_path__ + "img/01d@2x.7f93fbdb.svg";